var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-association"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._v(_vm._s(_vm.remarks||'未设置'))]),_c('div',{staticClass:"like"})])
}
var staticRenderFns = []

export { render, staticRenderFns }